import SearchIcon from '@mui/icons-material/Search';
import EditIcon from '@mui/icons-material/Edit';
import MoreIcon from '@mui/icons-material/MoreVert';

import ELEMENT from 'common/element';

import Link from 'components/common/Link/Link';
import IconButton from 'components/common/IconButton/IconButton';
import IconMenu from 'components/common/IconButton/IconMenu';

/**
 * Examples of IconButton.
 */

function IconButtonExamplePage(): JSX.Element {
  const menuItems = [
    [
      {
        as: Link,
        text: 'Item 1',
        href: '#',
      },
      {
        as: Link,
        text: 'Item 2',
        href: '#',
      },
    ],
  ];

  return (
    <section id="iconButton" className="ExamplesPage__Section">
      <h1 className="ExamplesPage__SectionTitle">IconButton</h1>
      <div className="ExamplesPage__Description">An icon that acts as a button.</div>

      <div className="ExamplesPage__ExampleRow--horiz">
        <IconButton icon={<SearchIcon />} tooltip="Search" />
        <IconButton icon={<EditIcon />} tooltip="Edit" />
        <IconMenu icon={<MoreIcon />} tooltip="More" sections={menuItems} testId={ELEMENT.dashboardHeaderMore} />
      </div>
    </section>
  );
}

export default IconButtonExamplePage;
